(function MediaTagDuplicates($, Adzuki)
{
	'use strict';

	/**
	 * Possible duplicate tags, for Media Tags' duplicate review (MEDIA-294) and for the check
	 * before any new tag is created (MEDIA-312). Two names match when they are the same once
	 * case, punctuation and spaces are ignored, a plural "s" or "es" or a trailing "photo" /
	 * "photos" is dropped, or when both are over five letters and one letter apart. Digits
	 * count and must match, so "Cruise 2025" and "Cruise 2026" stay apart.
	 *
	 * In the global bundle so every place a tag can be created uses the same rules.
	 */
	const MediaTagDuplicates = {
		key(name) {
			return String(name || '').toLowerCase()
				.replace(/[^a-z0-9]/g, '')
				.replace(/photos?$/, '')
				.replace(/(es|s)$/, '');
		},
		// edit distance, giving up once it passes limit
		distance(a, b, limit) {
			if (Math.abs(a.length - b.length) > limit) {
				return limit + 1;
			}

			let previous = [];

			for (let j = 0; j <= b.length; j++) {
				previous[j] = j;
			}

			for (let i = 1; i <= a.length; i++) {
				const current = [i];
				let rowMin    = i;

				for (let j = 1; j <= b.length; j++) {
					current[j] = Math.min(previous[j] + 1, current[j - 1] + 1, previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
					rowMin     = Math.min(rowMin, current[j]);
				}

				if (rowMin > limit) {
					return limit + 1;
				}

				previous = current;
			}

			return previous[b.length];
		},
		similar(a, b) {
			const keyA = this.key(a.name);
			const keyB = this.key(b.name);

			if (!keyA || !keyB) {
				return false;
			}

			if (keyA === keyB) {
				return true;
			}

			// one letter off, not one digit: the numbers in both names must match
			return keyA.length > 5 && keyB.length > 5
				&& keyA.replace(/\D/g, '') === keyB.replace(/\D/g, '')
				&& this.distance(keyA, keyB, 1) <= 1;
		},
		// the same name once case and spaces are ignored
		exact(a, b) {
			return String(a.name || '').trim().toLowerCase() === String(b.name || '').trim().toLowerCase();
		},
		// sets of two or more: each tag joins the first unclaimed tag it matches
		sets(tags) {
			const claimed = {};
			const sets    = [];

			tags.forEach((tag) => {
				if (claimed[tag.id]) {
					return;
				}

				const set = tags.filter(other => !claimed[other.id] && (other === tag || this.similar(tag, other)));

				if (set.length > 1) {
					set.forEach((member) => {
						claimed[member.id] = true;
					});
					sets.push(set);
				}
			});

			return sets;
		},
		// the tags a new name looks like, exact matches first; exceptId leaves out the tag
		// being renamed
		similarTo(name, tags, exceptId) {
			const candidate = { name: name };
			const matches   = (tags || []).filter(tag => String(tag.id) !== String(exceptId) && this.similar(candidate, tag));

			return matches.sort((a, b) => Number(this.exact(candidate, b)) - Number(this.exact(candidate, a)));
		},

		// ---- the agent's own and the global tags, for the pickers (MEDIA-312) ----
		cache: null,
		loadTags(baseUri) {
			if (!this.cache) {
				this.cache = fetch(`${baseUri}/MediaTag/tagNames`)
					.then(response => (response.ok ? response.json() : []))
					.then(data => (Array.isArray(data.tags) ? data.tags : []))
					.catch(() => {
						this.cache = null;

						return [];
					});
			}

			return this.cache;
		},
		// a tag just created, so the next check sees it without another request
		remember(tag) {
			if (this.cache && tag && tag.id) {
				this.cache = this.cache.then(tags => tags.concat({
					id    : tag.id,
					name  : tag.name,
					global: tag.global,
				}));
			}
		},
		// what the note under a tag box says
		describe(name, matches) {
			const names = matches.slice(0, 3).map(tag => '“' + tag.name + '”');
			const more  = matches.length > 3 ? ' and ' + (matches.length - 3) + ' more' : '';

			if (matches.length && this.exact({ name: name }, matches[0])) {
				return 'There’s already a tag called ' + names[0] + '.';
			}

			return '“' + name + '” looks like ' + names.join(', ') + more + '.';
		},
	};

	Adzuki.MediaTagDuplicates = MediaTagDuplicates;
}(jQuery, window.Adzuki || {}));
